import { createSlice } from "@reduxjs/toolkit";
import restaurantIdentityApi from "./api";
import { toast } from "react-toastify";

const initialState = {
  restaurantIdentities: [],
  pagination: { current: 1, pageSize: 10 },
  isLoading: false,
  isProcessing: false,
  isCompleted: false,
};

export const restaurantIdentitySlice = createSlice({
  name: "restaurantIdentity",
  initialState,
  reducers: {
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setIsProcessing: (state, action) => {
      if (action.payload === true) state.isCompleted = false;
      state.isProcessing = action.payload;
    },
    setIsCompleted: (state, action) => {
      state.isCompleted = action.payload;
    },
    setRestaurantIdentities: (state, action) => {
      state.restaurantIdentities = action.payload;
    },
    setPagination: (state, action) => {
      state.pagination = action.payload;
    },
    editRestaurantIdentity: (state, action) => {
      state.isCompleted = true;
      state.restaurantIdentities = state.restaurantIdentities.map((identity) =>
        identity._id === action.payload._id ? action.payload : identity
      );
    },
    removeRestaurantIdentity: (state, action) => {
      state.isCompleted = true;
      state.restaurantIdentities = state.restaurantIdentities.filter(
        (identity) => identity._id !== action.payload
      );
    },
  },
});

export const {
  setIsLoading,
  setIsCompleted,
  setIsProcessing,
  setRestaurantIdentities,
  setPagination,
  editRestaurantIdentity,
  removeRestaurantIdentity,
} = restaurantIdentitySlice.actions;

export const fetchRestaurantIdentities = (params) => {
  return async (dispatch) => {
    dispatch(setIsLoading(true));
    try {
      const data = await restaurantIdentityApi.getAll(params);
      dispatch(setRestaurantIdentities(data.data));
      dispatch(setPagination(data.meta));
    } catch (err) {
      console.log(err);
      toast.error("Lỗi khi tải danh sách căn cước công dân!");
    } finally {
      dispatch(setIsLoading(false));
    }
  };
};

export const verifyRestaurantIdentity = (id) => {
  return async (dispatch) => {
    try {
      dispatch(setIsProcessing(true));
      const data = await restaurantIdentityApi.verify(id);
      if (data.error) {
        toast.error(data.error.msg || "Lỗi khi xác minh căn cước công dân!");
      } else {
        dispatch(editRestaurantIdentity(data));
        toast.success("Xác minh căn cước công dân thành công!");
      }
    } catch (err) {
      console.log(err);
      toast.error("Lỗi khi xác minh căn cước công dân!");
    } finally {
      dispatch(setIsProcessing(false));
    }
  };
};

export const rejectRestaurantIdentity = (id, reason) => {
  return async (dispatch) => {
    try {
      dispatch(setIsProcessing(true));
      const data = await restaurantIdentityApi.reject(id, reason);
      if (data.error) {
        toast.error(data.error.msg || "Lỗi khi từ chối căn cước công dân!");
      } else {
        dispatch(editRestaurantIdentity(data));
        toast.success("Từ chối căn cước công dân thành công!");
      }
    } catch (err) {
      console.log(err);
      toast.error("Lỗi khi từ chối căn cước công dân!");
    } finally {
      dispatch(setIsProcessing(false));
    }
  };
};

export const deleteRestaurantIdentity = (id) => {
  return async (dispatch) => {
    try {
      dispatch(setIsProcessing(true));
      const data = await restaurantIdentityApi.delete(id);
      if (data.success) {
        dispatch(removeRestaurantIdentity(id));
        toast.success("Xóa căn cước công dân thành công!");
      } else {
        toast.error("Lỗi hệ thống, xóa căn cước công dân thất bại!");
      }
    } catch (err) {
      console.log(err);
      toast.error("Lỗi khi xóa căn cước công dân!");
    } finally {
      dispatch(setIsProcessing(false));
    }
  };
};

export default restaurantIdentitySlice.reducer;
